























import { updateSectionTestGroupApi } from '@/api/project'
import { EntityType, ProjectFormType, UpdateSectionTestGroupDto } from '@/api/project/model'
import { showError } from '@/utils/common'
import { computed, ComputedRef, defineComponent, reactive, toRefs,ref } from '@vue/composition-api'
import { updateOrCreateConversationMessageApi, updateOrCreateOnboardingPollApi, resetNumbersApi } from '@/api/project'
import { cloneDeep } from 'lodash'
export default defineComponent({
    components: {
    },
    props: {

    },
    setup(props, { root, emit }) {

        const projectUuId = computed(() => root.$route.params.projectUuId)
        const onboarding_poll_prefix=ref('S')
        const conversation_message_prefix=ref('Q')
        const state = reactive({
            show: false,
            loading: false,
            formType: ProjectFormType.Basic,
            onOpen: () => {
                state.show = true
            },
            disabled: computed(() => {
                return conversation_message_prefix.value==''||onboarding_poll_prefix.value==''||onboarding_poll_prefix.value.toUpperCase()==conversation_message_prefix.value.toUpperCase()
            }),
            onSave: async (formType?: number) => {
                try {
                    const data = await resetNumbersApi({ uuid: projectUuId.value ,onboarding_poll_prefix:onboarding_poll_prefix.value,
                        conversation_message_prefix: conversation_message_prefix.value})
                    emit('success')
                    state.show = false
                } catch (error) {
                    showError(error)
                }

            },
            filterInput: (value: string) => {
                // 允许字母、数字和小数点，不允许空格和其他符号
                const filteredValue = value.replace(/[^a-zA-Z.]/g, '').replace(/\s/g, '')
                    onboarding_poll_prefix.value = filteredValue
            },
            filterInput2: (value: string) => {
                // 允许字母、数字和小数点，不允许空格和其他符号
                const filteredValue = value.replace(/[^a-zA-Z.]/g, '').replace(/\s/g, '')
                    conversation_message_prefix.value = filteredValue
            }
        })

        return {
            ProjectFormType,
            EntityType,
            ...toRefs(state),
            onboarding_poll_prefix,
            conversation_message_prefix
        }
    }
})
